import { css } from 'linaria';

export const reviewsCatalogList = css`
  display: grid;
  grid-template-columns: repeat(3, 377px);
  padding: 0;
  margin: 0;
  column-gap: 24px;
  list-style: none;
  row-gap: 32px;

  @media (--only-desktop) {
    grid-template-columns: repeat(3, 297px);
  }

  @media (--only-tablet) {
    grid-template-columns: repeat(2, 318px);
    row-gap: 24px;
  }

  @media (--only-mobile) {
    grid-template-columns: repeat(1, 100%);
    row-gap: 16px;
    column-gap: 0;
  }
`;

export const reviewsCatalogItem = css`
  width: 100%;
  padding: 0;
  font-family: inherit;
  text-align: left;
  background-color: var(--background-primary);
  border: none;
  border-radius: var(--rounding-l);
  cursor: pointer;
`;

export const reviewsCatalogItemImage = css`
  && {
    width: 100%;
    height: 262px;
    object-fit: cover;

    @media (--only-desktop) {
      height: 206px;
    }

    @media (--only-tablet) {
      height: 221px;
    }

    @media (--only-mobile) {
      height: 210px;
    }
  }
`;

export const reviewsCatalogItemContent = css`
  padding: 24px;

  @media (--only-mobile) {
    padding: 16px;
  }
`;

export const reviewsCatalogItemRating = css`
  margin-bottom: 8px;
`;

export const reviewsCatalogItemTextWrapper = css`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 8px;
`;

export const reviewsCatalogItemText = css`
  display: -webkit-box;
  width: 290px;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;

  @media (--to-desktop) {
    width: 216px;
    -webkit-line-clamp: 3;
  }

  @media (--only-mobile) {
    width: 71.8vw;
  }
`;

export const reviewsCatalogItemAddWrapper = css`
  display: flex;
  column-gap: 8px;
`;

export const reviewsCatalogButton = css`
  margin: 0 auto;
  margin-top: 32px;

  @media (--only-mobile) {
    width: 100%;
    margin-top: 24px;
  }
`;
